import { render, staticRenderFns } from "./ModalDash.vue?vue&type=template&id=4f4005b6&"
import script from "./ModalDash.vue?vue&type=script&lang=js&"
export * from "./ModalDash.vue?vue&type=script&lang=js&"
import style0 from "./ModalDash.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports